import { Tooltip } from 'antd';

export type LanguageFilterValue = 'UZ' | 'RU' | 'EN' | null;

const OPTIONS: Array<{
  value: 'UZ' | 'RU' | 'EN';
  label: string;
  flag: string;
  hex: string;
  bg: string;
}> = [
  { value: 'UZ', label: "O'zbek", flag: '🇺🇿', hex: '#0EA5E9', bg: '#ECFEFF' },
  { value: 'RU', label: 'Русский', flag: '🇷🇺', hex: '#6366F1', bg: '#EEF2FF' },
  { value: 'EN', label: 'English', flag: '🇬🇧', hex: '#10B981', bg: '#ECFDF5' },
];

interface LanguageFilterProps {
  /** Current selection — `null` = no filter. */
  value: LanguageFilterValue;
  onChange: (next: LanguageFilterValue) => void;
}

/**
 * Inline pill row for preferred-language filter (UZ / RU / EN).
 * Sits next to the page title alongside the call-colour pills.
 */
export const LanguageFilter: React.FC<LanguageFilterProps> = ({
  value,
  onChange,
}) => {
  return (
    <span style={{ display: 'inline-flex', gap: 6, marginLeft: 12, verticalAlign: 'middle' }}>
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <Tooltip
            key={opt.value}
            title={active ? 'Filterni olib tashlash' : `Filter: ${opt.label}`}
          >
            <button
              type="button"
              onClick={() => onChange(active ? null : opt.value)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '4px 10px',
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.15s',
                color: active ? '#fff' : opt.hex,
                background: active ? opt.hex : opt.bg,
                border: `1px solid ${active ? opt.hex : opt.hex + '33'}`,
                lineHeight: 1.2,
                whiteSpace: 'nowrap',
              }}
            >
              <span style={{ fontSize: 14, lineHeight: 1 }}>{opt.flag}</span>
              {opt.value}
            </button>
          </Tooltip>
        );
      })}
    </span>
  );
};
